import React from 'react'
import "./Footer.css"
import { Link } from 'react-scroll'

const Footer = () => {
    return (
        <>

            <section>
                <section>
                    <div className="container-fluid pt-lg-4 pb-lg-4  d-md-none d-none d-lg-block" style={{ backgroundColor: "black" }}>
                        <div className="container-lg  p-3 Montserrat pt-5 pb-4">
                            <div className="row g-4 d-flex justify-content-between text-white">
                                <div className="col-lg-3">
                                    <div className='mb-4 ' >
                                        <h6 className=' text-decoration-none mt-2 ' style={{ fontSize: "18px", fontWeight: "500", textTransform: "uppercase",color:"gold" }} >About P.A.S</h6>
                                    </div>
                                    <div className='pt-2'>
                                        <p className=' mb-3' style={{ color: "#fff", fontSize: "14.6px", lineHeight: "25px", fontWeight: "400" }} >
                                            P.A.S. Glam Beauty Studio & Institute is a professional beauty salon and training institute in Pune.
                                            <br />
                                            We specialize in makeup, hair, and skincare services, along with certified beautician and makeup artist courses. <br />
                                             Personality According Style 
                                        </p>
                                    </div>
                                </div>

                                <div className="col-lg-2">
                                    <div className='mb-4 ' >
                                        <h6 className=' text-decoration-none mt-2 ' style={{ fontSize: "18px", fontWeight: "500", textTransform: "uppercase" ,color:"gold"}} >Information</h6>
                                    </div>
                                    <div className='mt-3 pt-2' style={{ color: "#fff", fontSize: "16px", lineHeight: "19px", fontWeight: "400", cursor: "pointer" }}>
                                        <Link to='main' className='text-decoration-none FooterHover' >
                                            <i class="fa-solid fa-angle-right"></i>
                                            <p>Home</p>
                                        </Link>

                                        <Link to='services' className='text-decoration-none FooterHover' >
                                            <i class="fa-solid fa-angle-right "></i>
                                            <p>Our Services</p>
                                        </Link>

                                        <Link to='aboutus' className='text-decoration-none FooterHover' >
                                            <i class="fa-solid fa-angle-right"></i>
                                            <p>About Us</p>
                                        </Link>

                                         <Link to='gallery' className='text-decoration-none FooterHover' >
                                            <i class="fa-solid fa-angle-right"></i>
                                            <p>Gallery</p>
                                        </Link>

                                        <Link to='contact' className='text-decoration-none FooterHover' >
                                            <i class="fa-solid fa-angle-right"></i>
                                            <p>Contac Us</p>
                                        </Link>
                                    </div>
                                </div>

                                <div className="col-lg-3">
                                    <div className='mb-4' >
                                        <h6 className=' text-decoration-none mt-2' style={{ fontSize: "18px", fontWeight: "500", textTransform: "uppercase",color:"gold" }} >connect info</h6>
                                    </div>
                                    <div className='mt-3 pt-2'>
                                        <p className='MontserratFont'>
                                            <h6 className='mb-2' style={{ fontWeight: "500", fontSize: "13.5px", lineHeight: "20px", color: "#fff" }}>
                                                <i class="fa-solid fa-location-dot me-3" style={{ color: "#D4AF37 " }}></i>
                                                SHOP NO 1, Atharva Niwas, near Durga Mata Mandir, opp. to Kokan Katta Khanaval, Shriram Nagar, Dhankawadi, Pune, Maharashtra 411046
                                            </h6>
                                        </p>
                                        <p className='mt-2 MontserratFont'>
                                            <a href='tel:9921589794' className='text-decoration-none NumberHover' style={{ cursor: "pointer" }}>
                                                <h6 className='mb-3' style={{ fontWeight: "500", fontSize: "14px" }}>
                                                    <i class="fa-solid fa-phone me-3" style={{ color: "#D4AF37 " }}></i>
                                                    9921589794
                                                </h6>
                                            </a>
                                        </p>

                                        <p className='mt-2 MontserratFont'>
                                            <a href='tel:9022465871' className='text-decoration-none NumberHover' style={{ cursor: "pointer" }}>
                                                <h6 className='mb-3' style={{ fontWeight: "500", fontSize: "14px" }}>
                                                    <i class="fa-solid fa-phone me-3" style={{ color: "#D4AF37 " }}></i>
                                                   9022465871
                                                </h6>
                                            </a>
                                        </p>
                                    </div>
                                </div>

                                <div className="col-lg-3">
                                    <div className='mb-4' >
                                        <h6 className=' text-decoration-none mt-2' style={{ fontSize: "18px", fontWeight: "500", textTransform: "uppercase",color:"gold" }} >Our Company</h6>
                                    </div>
                                    <div className='mt-3 pt-0'>
                                        <p className='d-flex MontserratFont' >
                                            <span style={{ fontWeight: "500", fontSize: "15px", color: "#fff", lineHeight: "35px" }}>
                                                Mon – Sun : 11:00 AM to 8:00 PM
                                            </span>
                                        </p>

                                        <li className='' style={{listStyle:"none"}}>
                                            <span className='SocialIcon  text-center'>
                                                <a href="https://www.facebook.com/share/17ZCX5cFaS/" target="_blank"><i className="fa-brands fa-facebook-f "></i></a>
                                                <a href="https://www.instagram.com/pas_glam_beauty_studio_and_ins?igsh=MW9oaHQwazk3Z2h3MA==" target="_blank"><i className="fa-brands fa-instagram ms-3" ></i></a>
                                            </span>
                                        </li>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container-fluid p-0 d-lg-none d-md-block " style={{ backgroundColor: "black" }}>
                        <div className="container-lg  p-3 Montserrat pt-5 pb-4">
                            <div className="row g-4 d-flex justify-content-between text-white">
                                <div className="col-lg-3 col-md-5 col-sm-5">
                                    <div className='mb-3 ' >
                                        <h6 className=' text-decoration-none mt-2 ' style={{ fontSize: "18px", fontWeight: "500", textTransform: "uppercase",color:"gold" }} >About P.A.S</h6>
                                    </div>
                                    <div className='pt-2'>
                                        <p className=' mb-3' style={{ color: "#fff", fontSize: "15px", lineHeight: "25px", fontWeight: "400" }} >
                                            P.A.S. Glam Beauty Studio & Institute is a professional beauty salon and training institute in Pune.
                                            <br />
                                            We specialize in makeup, hair, and skincare services, along with certified beautician and makeup artist courses.
                                            <br />
                                             Personality According Style
                                        </p>
                                    </div>
                                </div>

                                <div className="col-lg-2 col-md-5 col-sm-5">
                                    <div className='mb-2 ' >
                                        <h6 className=' text-decoration-none mt-2 ' style={{ fontSize: "18px", fontWeight: "500", textTransform: "uppercase",color:"gold" }} >Information</h6>
                                    </div>
                                    <div className='mt-3 pt-2' style={{ color: "#fff", fontSize: "15px", lineHeight: "19px", fontWeight: "400", cursor: "pointer" }}>
                                        <Link to='main' className='text-decoration-none FooterHover' >
                                            <i class="fa-solid fa-angle-right"></i>
                                            <p>Home</p>
                                        </Link>

                                        <Link to='services' className='text-decoration-none FooterHover' >
                                            <i class="fa-solid fa-angle-right "></i>
                                            <p>Our Services</p>
                                        </Link>

                                        <Link to='aboutus' className='text-decoration-none FooterHover' >
                                            <i class="fa-solid fa-angle-right"></i>
                                            <p>About Us</p>
                                        </Link>

                                        <Link to='gallery' className='text-decoration-none FooterHover' >
                                            <i class="fa-solid fa-angle-right"></i>
                                            <p>Gallery</p>
                                        </Link>

                                        <Link to='contact' className='text-decoration-none FooterHover' >
                                            <i class="fa-solid fa-angle-right"></i>
                                            <p>Contac Us</p>
                                        </Link>
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-5 col-sm-5">
                                    <div className='mb-2' >
                                        <h6 className=' text-decoration-none mt-2' style={{ fontSize: "18px", fontWeight: "500", textTransform: "uppercase",color:"gold" }} >connect info</h6>
                                    </div>
                                    <div className='mt-3 pt-2'>
                                        <p className='MontserratFont'>
                                            <h6 className='mb-2' style={{ fontWeight: "500", fontSize: "15px", lineHeight: "20px", color: "#fff" }}>
                                                <i class="fa-solid fa-location-dot me-3" style={{ color: "#D4AF37 " }}></i>
                                                SHOP NO 1, Atharva Niwas, near Durga Mata Mandir, opp. to Kokan Katta Khanaval, Shriram Nagar, Dhankawadi, Pune, Maharashtra 411046
                                            </h6>
                                        </p>
                                        <p className='mt-2 MontserratFont'>
                                            <a href='tel:9921589794' className='text-decoration-none NumberHover' style={{ cursor: "pointer" }}>
                                                <h6 className='mb-3' style={{ fontWeight: "500", fontSize: "15px" }}>
                                                    <i class="fa-solid fa-phone me-3" style={{ color: "#D4AF37 " }}></i>
                                                 9921589794
                                                </h6>
                                            </a>
                                        </p>
                                        <p className='mt-2 MontserratFont'>
                                            <a href='tel:9022465871' className='text-decoration-none NumberHover' style={{ cursor: "pointer" }}>
                                                <h6 className='mb-3' style={{ fontWeight: "500", fontSize: "15px" }}>
                                                    <i class="fa-solid fa-phone me-3" style={{ color: "#D4AF37 " }}></i>
                                                 9022465871
                                                </h6>
                                            </a>
                                        </p>
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-5 col-sm-5">
                                    <div className='mb-2' >
                                        <h6 className=' text-decoration-none mt-2' style={{ fontSize: "18px", fontWeight: "500", textTransform: "uppercase" ,color:"gold"}} >Our Company</h6>
                                    </div>
                                    <div className='mt-3 pt-2'>
                                        <p className='d-flex MontserratFont' >
                                            <span style={{ fontWeight: "500", fontSize: "15px", color: "#b8b8b8", lineHeight: "30px" }}>
                                                Mon – Sun : 11:00 AM to 8:00 PM
                                            </span>
                                        </p>

                                        <li style={{listStyle:"none"}}>
                                            <span className='SocialIcon  text-center'>
                                                <Link to=" " target="_blank"><i className="fa-brands fa-facebook-f "></i></Link>
                                                <Link to="https://www.instagram.com/satvaagro?utm_source=qr&igsh=MXE4M2VpcWM4cWVrcA==" target="_blank"><i className="fa-brands fa-instagram ms-2" ></i></Link>
                                            </span>
                                        </li>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section>
                    <div className="container-fluid " style={{ backgroundColor: "black" }}>
                        <div className="container-lg FooterBottomSection " >
                            <div className="d-flex justify-content-between align-items-center pt-3" >
                                <div className='' >
                                    © 2025 P.A.S. Glam Beauty Studio & Institute — All Rights Reserved.
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>

        </>
    )
}

export default Footer